/*
 * Copyright (c) 2022. Haodong JU
 */

import i18n from '@/i18n'
import { Remember } from '@/GlobalSettings'

console.log(Remember.showStorageManagement)
console.log(!Remember.showStorageManagement)
export const restaurantMenu = [
  {
    icon: 'mdi-view-dashboard',
    title: 'dayStatistical',
    to: '/',
    mustshow: true,
  },
  {
    divider: true,

  },
  {
    header: i18n.t('basicInformation'),
    mustshow: true,
  },
  {
    group: '/dishes',
    icon: 'mdi-shape-plus',
    title: 'product',
    key: 'product',
    groupTo: '/dishes/dishes-manage',
    children: [
      {
        title: 'category',
        icon: 'mdi-label',
        to: 'labels-manage',
        brief: true,
      },

      {
        title: 'product',
        icon: 'mdi-food-fork-drink',
        to: 'dishes-manage',
        brief: true,
      },
      {
        title: 'AttributeGroup',
        icon: 'mdi-food-fork-drink',
        to: 'attribute-group',
        brief: true,
      },
      {
        title: 'allergicSource',
        icon: 'mdi-help',
        to: 'allergen-setting',
      },
      {
        title: 'discountRule',
        icon: 'mdi-help',
        to: 'discount-rules-setting',
      },
    ],
  },
  {
    title: 'menu',
    icon: 'mdi-silverware',
    to: '/dishes/buffet-child-setting',
    key: 'menu',
  },
  {
    hide: Remember.showStorageManagement === '0',
    group: '/storage',
    icon: 'mdi-server',
    title: 'storage',
    key: 'bills',
    groupTo: '/storage/inventory',
    children: [
      {
        title: 'inventory',
        icon: 'mdi-package-variant-closed',
        to: 'inventory',
        key: 'inventory',
      },
      {
        title: 'changeRecord',
        icon: 'mdi-package-variant-closed',
        to: 'changeRecord',
        key: 'changeRecord',
      },
      {
        title: 'resource',
        icon: 'mdi-package-variant-closed',
        to: 'resource',
        key: 'resource',
      },
      {
        title: 'connection',
        icon: 'mdi-connection',
        key: 'connection',
        to: 'connection',
      },
      {
        title: 'unitSet',
        icon: 'mdi-pencil-ruler',
        key: 'unitSet',
        to: 'unitSet',
      },
      {
        title: 'unit',
        icon: 'mdi-pencil-ruler',
        key: 'unit',
        to: 'unit',
      },
    ],
  },
  {
    title: 'table',
    icon: 'mdi-table-chair',
    key: 'table',
    to: '/Tables/tables-manage',
  },
  {
    icon: 'mdi-account-multiple-outline',
    title: 'staff',
    key: 'staff',
    to: '/Tables/person-manage',
  },
  {
    header: i18n.t('billsAndStatistics'),
    mustshow: true,
  },

  {
    group: '/bills',
    icon: 'mdi-file-document',
    title: 'bill',
    key: 'bills',
    groupTo: '/bills/history-bills',
    children: [
      {
        title: 'cashBook',
        icon: 'mdi-cash-register',
        key: 'cashBook',
        to: 'cashbook',
      },
      {
        title: 'allBills',
        icon: 'mdi-file-document-multiple',
        to: 'history-bills',
        key: 'allBills',
        brief: true,
      },
      {
        title: 'vouchers',
        icon: 'mdi-smart-card-outline',
        key: 'vouchers',
        to: 'member-card-sale-record',
      },
    ],
  },

  {
    title: 'marketingStatistics',
    icon: 'mdi-chart-line',
    key: 'marketingStatistics',
    to: '/Sales/dish-statistics',
  },
  {
    title: 'exportAndPrint',
    icon: 'mdi-table-arrow-right',
    key: 'exportAndPrint',
    to: '/bills/export',
  },
  {
    header: i18n.t('otherSetting'),
    mustshow: true,
  },
  {
    hide: false,
    title: 'activeReserve',
    icon: 'mdi-account-edit',
    key: 'openReserve',
    to: '/reserve/openReserve',
  },
  {
    group: '/marketLabel',
    icon: 'mdi-account-edit',
    title: 'marketLabel',
    children: [
      {
        title: 'ingredientSetting',
        icon: 'mdi-help',
        to: 'ingredientSetting',
      },
      {
        title: 'ingredientSelect',
        icon: 'mdi-help',
        to: 'ingredientSelect',
      },
      {
        title: 'SettingSKU',
        icon: 'mdi-help',
        to: 'SettingSKU',
      },
      // {
      //   title: 'ManageSKU',
      //   icon: 'mdi-help',
      //   to: 'ManageSKU',
      // },
      // {
      //   title: 'LabelPrint',
      //   icon: 'mdi-help',
      //   to: 'LabelPrint',
      // },
    ],
  },
  {
    hide: true,
    group: '/reserve',
    icon: 'mdi-account-edit',
    title: 'reserveSetting',
    children: [
      {
        title: 'openReserve',
        icon: 'mdi-help',
        to: 'openReserve',
      },
      {
        title: 'usefulTable',
        icon: 'mdi-help',
        to: 'usefulTable',
      },
      {
        title: 'openTime',
        icon: 'mdi-silver-ware',
        to: 'openTime',
      },
      {
        title: 'tableRule',
        icon: 'mdi-silver-ware',
        to: 'tableRule',
      },
    ],
  },
  {
    icon: 'mdi-printer',
    title: 'printer',
    key: 'printer',
    to: '/print/section-printer-setting',
  },
  {
    icon: 'mdi-note-edit',
    title: 'printTemplate',
    key: 'printTemplate',
    to: '/print/bon-template',
  },
  {
    group: '/settings',
    icon: 'mdi-account-cog',
    title: 'setting',
    mustshow: true,
    children: [

      {
        group: '/TakeawaySetting',
        title: 'togo',
        icon: 'mdi-dots-horizontal-circle-outline',
        children: [
          {
            title: 'distributionDistance',
            icon: 'mdi-help',
            to: 'delivery-range-setting',
          },
          {
            title: 'openTime',
            icon: 'mdi-help',
            to: 'open-time-setting',
          },
        ],
      },
      {
        group: '/settings',
        title: 'image',
        icon: 'mdi-image-area',
        children: [

          {
            title: 'restaurantImage',
            icon: 'mdi-silver-ware',
            to: 'restaurant-image',
          },
          {
            title: 'selfServiceOrderingMachine',
            icon: 'mdi-silver-ware',
            to: 'banner-image',
          },
        ],
      },
      {
        title: 'pay',
        icon: 'mdi-help',
        to: 'paymentpage',
      },
      {
        title: 'restaurantInfo',
        icon: 'mdi-silver-ware',
        to: 'restaurant-info',
      },
    ],
  },
]

export const bubbleTeaMenu = restaurantMenu
